import config from "./campaignLandingConfig.json";

export const CAMPAIGN_LANDINGS = Object.freeze(config.landings);

export const CAMPAIGN_LANDING_ROUTES = Object.freeze(
  CAMPAIGN_LANDINGS.map(({ id, path }) => ({ id, path })),
);

export const PORTAL_ASSESSMENT_URL = config.portalUrl;

export function getCampaignLanding(id) {
  return CAMPAIGN_LANDINGS.find((landing) => landing.id === id) || null;
}
